import { IUser } from "../../modules/core/models/user.model";


export const usersMock: IUser[] = [
  {
    userID: '1',
    userName: 'JohnDoe',
    name: 'John',
    surname: 'Doe',
    email: 'john.doe@example.com',
    emailConfirmed: true,
    lockoutEnabled: false,
    roles: ['Admin', 'Ekapy'],
    phoneNumberConfirmed: false,
    assignedCountRequests: 0,
    // assignedSupplierRequests: 0,
    // assignedProductCategoriesRequests: 0,
  },
  {
    userID: '2',
    userName: 'JaneSmith',
    name: 'Jane',
    surname: 'Smith',
    email: 'jane.smith@example.com',
    emailConfirmed: true,
    lockoutEnabled: false,
    roles: ['Ekapy'],
    phoneNumberConfirmed: false,
    assignedCountRequests: 0,
    // assignedSupplierRequests: 0,
    // assignedProductCategoriesRequests: 0,
  },
  {
    userID: '3',
    userName: 'MikeJohnson',
    name: 'Mike',
    surname: 'Johnson',
    email: 'mike.johnson@example.com',
    emailConfirmed: true,
    lockoutEnabled: false,
    roles: ['Ekapy'],
    phoneNumberConfirmed: false,
    assignedCountRequests: 0,
    // assignedSupplierRequests: 0,
    // assignedProductCategoriesRequests: 0,
  },
  {
    userID: '4',
    userName: 'EmilyBrown',
    name: 'Emily',
    surname: 'Brown',
    email: 'emily.brown@example.com',
    emailConfirmed: true,
    lockoutEnabled: false,
    roles: ['Admin'],
    phoneNumberConfirmed: false,
    assignedCountRequests: 0,
    // assignedSupplierRequests: 0,
    // assignedProductCategoriesRequests: 0,
  },
  {
    userID: '5',
    userName: 'ChrisDavis',
    name: 'Chris',
    surname: 'Davis',
    email: 'chris.davis@example.com',
    emailConfirmed: true,
    lockoutEnabled: false,
    roles: ['Ekapy'],
    phoneNumberConfirmed: false,
    assignedCountRequests: 0,
    // assignedSupplierRequests: 0,
    // assignedProductCategoriesRequests: 0,
  },
  {
    userID: '6',
    userName: 'LauraWilson',
    name: 'Laura',
    surname: 'Wilson',
    email: 'laura.wilson@example.com',
    emailConfirmed: true,
    lockoutEnabled: false,
    roles: ['Ekapy'],
    phoneNumberConfirmed: false,
    assignedCountRequests: 0,
    // assignedSupplierRequests: 0,
    // assignedProductCategoriesRequests: 0,
  },
  {
    userID: '7',
    userName: 'DavidClark',
    name: 'David',
    surname: 'Clark',
    email: 'david.clark@example.com',
    emailConfirmed: true,
    lockoutEnabled: false,
    roles: ['Admin'],
    phoneNumberConfirmed: false,
    assignedCountRequests: 0,
    // assignedSupplierRequests: 0,
    // assignedProductCategoriesRequests: 0,
  },
  {
    userID: '8',
    userName: 'SarahLewis',
    name: 'Sarah',
    surname: 'Lewis',
    email: 'sarah.lewis@example.com',
    emailConfirmed: true,
    lockoutEnabled: false,
    roles: ['Ekapy'],
    phoneNumberConfirmed: false,
    assignedCountRequests: 0,
    // assignedSupplierRequests: 0,
    // assignedProductCategoriesRequests: 0,
  },
  {
    userID: '9',
    userName: 'DanielWalker',
    name: 'Daniel',
    surname: 'Walker',
    email: 'daniel.walker@example.com',
    emailConfirmed: true,
    lockoutEnabled: false,
    roles: ['Ekapy', 'Supplier'],
    phoneNumberConfirmed: false,
    assignedCountRequests: 0,
    // assignedSupplierRequests: 0,
    // assignedProductCategoriesRequests: 0,
  },
  {
    userID: '10',
    userName: 'JessicaHall',
    name: 'Jessica',
    surname: 'Hall',
    email: 'jessica.hall@example.com',
    emailConfirmed: true,
    lockoutEnabled: false,
    roles: ['Ekapy'],
    phoneNumberConfirmed: false,
    assignedCountRequests: 0,
    // assignedSupplierRequests: 0,
    // assignedProductCategoriesRequests: 0,
  },
  {
    userID: '11',
    userName: 'PaulAllen',
    name: 'Paul',
    surname: 'Allen',
    email: 'paul.allen@example.com',
    emailConfirmed: true,
    lockoutEnabled: false,
    roles: ['Ekapy'],
    phoneNumberConfirmed: false,
    assignedCountRequests: 0,
    // assignedSupplierRequests: 0,
    // assignedProductCategoriesRequests: 0,
  },
  {
    userID: '12',
    userName: 'NancyYoung',
    name: 'Nancy',
    surname: 'Young',
    email: 'nancy.young@example.com',
    emailConfirmed: true,
    lockoutEnabled: false,
    roles: ['Ekapy', 'Admin'],
    phoneNumberConfirmed: false,
    assignedCountRequests: 0,
    // assignedSupplierRequests: 0,
    // assignedProductCategoriesRequests: 0,
  },
  {
    userID: '13',
    userName: 'StevenKing',
    name: 'Steven',
    surname: 'King',
    email: 'steven.king@example.com',
    emailConfirmed: true,
    lockoutEnabled: false,
    roles: ['Ekapy'],
    phoneNumberConfirmed: false,
    assignedCountRequests: 0,
    // assignedSupplierRequests: 0,
    // assignedProductCategoriesRequests: 0,
  },
  {
    userID: '14',
    userName: 'KarenScott',
    name: 'Karen',
    surname: 'Scott',
    email: 'karen.scott@example.com',
    emailConfirmed: true,
    lockoutEnabled: false,
    roles: ['Supplier'],
    phoneNumberConfirmed: false,
    assignedCountRequests: 0,
    // assignedSupplierRequests: 0,
    // assignedProductCategoriesRequests: 0,
  },
  {
    userID: '15',
    userName: 'BrianGreen',
    name: 'Brian',
    surname: 'Green',
    email: 'brian.green@example.com',
    emailConfirmed: true,
    lockoutEnabled: false,
    roles: ['Ekapy'],
    phoneNumberConfirmed: false,
    assignedCountRequests: 0,
    // assignedSupplierRequests: 0,
    // assignedProductCategoriesRequests: 0,
  },
  {
    userID: '16',
    userName: 'RebeccaHarris',
    name: 'Rebecca',
    surname: 'Harris',
    email: 'rebecca.harris@example.com',
    emailConfirmed: true,
    lockoutEnabled: false,
    roles: ['Ekapy'],
    phoneNumberConfirmed: false,
    assignedCountRequests: 0,
    // assignedSupplierRequests: 0,
    // assignedProductCategoriesRequests: 0,
  },
  {
    userID: '17',
    userName: 'GeorgeMartinez',
    name: 'George',
    surname: 'Martinez',
    email: 'george.martinez@example.com',
    emailConfirmed: true,
    lockoutEnabled: false,
    roles: ['Ekapy'],
    phoneNumberConfirmed: false,
    assignedCountRequests: 0,
    // assignedSupplierRequests: 0,
    // assignedProductCategoriesRequests: 0,
  },
  {
    userID: '18',
    userName: 'PatriciaRobinson',
    name: 'Patricia',
    surname: 'Robinson',
    email: 'patricia.robinson@example.com',
    emailConfirmed: true,
    lockoutEnabled: false,
    roles: ['Ekapy', 'Supplier'],
    phoneNumberConfirmed: false,
    assignedCountRequests: 0,
    // assignedSupplierRequests: 0,
    // assignedProductCategoriesRequests: 0,
  },
  {
    userID: '19',
    userName: 'EdwardClark',
    name: 'Edward',
    surname: 'Clark',
    email: 'edward.clark@example.com',
    emailConfirmed: true,
    lockoutEnabled: false,
    roles: ['Ekapy'],
    phoneNumberConfirmed: false,
    assignedCountRequests: 0,
    // assignedSupplierRequests: 0,
    // assignedProductCategoriesRequests: 0,
  },
  {
    userID: '20',
    userName: 'MeganHill',
    name: 'Megan',
    surname: 'Hill',
    email: 'megan.hill@example.com',
    emailConfirmed: true,
    lockoutEnabled: false,
    roles: ['Ekapy', 'Admin'],
    phoneNumberConfirmed: false,
    assignedCountRequests: 0,
    // assignedSupplierRequests: 0,
    // assignedProductCategoriesRequests: 0,
  },
];
